<template>
    <div>
        <p class="created-by">{{createdBy}}</p>
        <p class="subhead" v-if="category && createdTime">
            {{category}} • <localized-date-time v-if="createdTime" :instant="createdTime" />
        </p>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
export default Vue.extend({
    name: 'CardHeader',
    props: {
        createdBy: String,
        category: String,
        createdTime: Temporal.Instant as unknown as PropType<Temporal.Instant>,
    }
})
</script>
